// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oimage[data-v-5a85bdae] img{max-width:unset}.horizontal-scroll[data-v-5a85bdae]:focus{outline:2px solid #36c0b6;outline-offset:-2px}.horizontal-scroll[data-v-5a85bdae]{scroll-behavior:smooth}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
